import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxUidModule, NgxUidService } from 'ngx-uid';
import { v4 as uuid } from 'uuid';



import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { SharedModule } from './shared/shared.module';

export class UidFactory implements NgxUidService {
  next() { return uuid(); }
}

@NgModule({
  imports: [
    BrowserModule.withServerTransition({ appId: 'pensionOutlook' }),
    BrowserAnimationsModule,
    AppRoutingModule,
    CoreModule,
    NgxUidModule.forRoot(),
    SharedModule,
    NgbModule
  ],
  declarations: [
    AppComponent,
  ],
  providers: [
    {
      provide: NgxUidService,
      useClass: UidFactory,
    },
  ],
  bootstrap: [
    AppComponent
  ]
})
export class AppModule { }